/**
 * Add a customValidity property setter to HTMLInputElements.
 * This enables data-binding to the setCustomValidity method.
 */
Object.defineProperty(HTMLInputElement.prototype, 'customValidity', {
	set(value: string) {
		this.setCustomValidity(value);
	}
});
